<template>
  <sSelect
    :disabled="disabled || loading"
    filterable
    :loading="loading"
    :loading-text="$t('Common.Loading')"
    :multiple="multiple"
    :placeholder="$t('Common.organizerSearchPlaceholder')"
    remote
    :remote-method="search"
    reserve-keyword
    :value="mutableValue"
    @closeAllSelect="clearOrganizers"
    @update:value="handleOrganization">
    <sOption
      v-for="organizer in organizers"
      :key="organizer.organizationId"
      :label="`${organizer.title} (${organizer.usreou})`"
      :value="organizer.organizationId"/>
  </sSelect>
</template>
<script>
import { debounce } from 'toolkit/utils/util'
import OrganizerSettingApi from '@/api/organizerSettingApi'
const organizer_setting_api = new OrganizerSettingApi()

export default {
  name: 'organizersSelect',
  data() {
    return {
      loading: false,
      organizers: [],
    }
  },
  methods: {
    handleOrganization(id) {
      if (this.multiple) {
        this.$emit('on-change', id)
      }
      const organizer = this.organizers.find(({ organizationId }) => organizationId === id)
      this.$emit('on-change', organizer)
    },
    search: debounce(function (searchPhrase) {
      if (searchPhrase) {
        this.loading = true
        organizer_setting_api.searchOrganizers(searchPhrase)
          .then((res) => {
            this.organizers = res
            this.loading = false
          })
      } else {
        this.clearOrganizers()
      }
    }, 500),
    clearOrganizers() {
      if (this.multiple) {
        this.organizers = []
      }
    },
  },
  computed: {
    mutableValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  props: {
    value: {
      type: [String, Number, Array],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
